import React from 'react';
import { AnimatedSection } from '../../components/ui/AnimatedSection';
import { Button } from '../../components/ui/Button';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FatLossScience() {
  return <main className="w-full pt-32 pb-24 bg-dark min-h-screen" data-id="element-704">
      <article className="max-w-3xl mx-auto px-6" data-id="element-705">
        <AnimatedSection data-id="element-706">
          <Link to="/blog" className="inline-flex items-center text-gold hover:text-white transition-colors mb-8 text-sm font-bold uppercase tracking-wider" data-id="element-707">
            <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-708" />
            Back to Insights
          </Link>

          <div className="mb-12" data-id="element-709">
            <span className="text-gold text-xs font-bold uppercase tracking-wider px-3 py-1 border border-gold/30 rounded-full mb-6 inline-block" data-id="element-710">
              Science
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 font-heading leading-tight" data-id="element-711">
              The Science of Fat Loss: Beyond Calories In, Calories Out
            </h1>
            <p className="text-xl text-muted leading-relaxed mb-6" data-id="element-712">
              Fat loss is not math — it's physiology.
            </p>
            <div className="flex items-center text-sm text-muted font-medium border-t border-border pt-6" data-id="element-713">
              <span data-id="element-714">Aug 20, 2025</span>
              <span className="mx-3" data-id="element-715">•</span>
              <span data-id="element-716">7 min read</span>
            </div>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.2} className="prose prose-invert prose-lg max-w-none prose-headings:font-heading prose-headings:text-white prose-a:text-gold hover:prose-a:text-white prose-strong:text-white" data-id="element-717">
          <p data-id="element-718">
            You've been told fat loss is simple. Eat less, move more. But if
            that worked, you wouldn't still be stuck.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-719">
            Why That Model Fails
          </h3>
          <p data-id="element-720">Your body is not a calculator. It's a system.</p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-721">
            What Actually Controls Fat Loss
          </h3>
          <p data-id="element-722">
            Hormones, insulin, cortisol, muscle mass, and sleep — not just
            calories.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-723">
            What This Looks Like
          </h3>
          <p data-id="element-724">You eat less, train more, and still don't see results.</p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-725">
            What This Means for You
          </h3>
          <p data-id="element-726">Your body is not responding because something deeper is off.</p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-727">
            The BioShift Perspective
          </h3>
          <p data-id="element-728">We restore metabolism, hormonal function, and energy systems.</p>
          <p className="text-xl font-medium text-gold italic mt-8" data-id="element-729">
            Fat loss is not about doing more. It's about fixing what's not
            working.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.3} data-id="element-730">
          <div className="mt-16 pt-12 border-t border-border text-center bg-surface p-10 rounded-lg" data-id="element-731">
            <h3 className="text-2xl font-bold text-white mb-4 font-heading" data-id="element-732">
              Ready to fix what's not working?
            </h3>
            <p className="text-muted mb-8 max-w-lg mx-auto" data-id="element-733">
              Stop fighting your physiology and start working with it. Apply for
              coaching today.
            </p>
            <Button href="https://holistic-health.bioshift.net/calender-booking" size="lg" data-id="element-734">
              Apply for Coaching
            </Button>
          </div>
        </AnimatedSection>
      </article>
    </main>;
}